import React, { useRef } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import "../../../assets/css/master.css"
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { formatTimeHourMinute, onlyNumeric, TimeHour } from '../../commonClass/CommonValidation';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { generatePDF } from '../../commonClass/CommonValidation'
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomSelection from '../../../customControl/CustomSelection';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../../customControl/CustomTable';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import CommonFilter from '../../../customControl/CommonFilter';


const Sightseeingmaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [citydata, setCityData] = useState([]);
    const [cityid, setCity] = useState(0);
    // const [locationId, setLocationId] = useState(0);
    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState();
    // const [alllocation, setAllLocation] = useState([]);
    const [sightseeingListdata, setSightseeingListdata] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [hoursTime, setHoursTime] = useState(null);

    const [searchvalue, setSearchValue] = useState("");
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisabled] = useState(false);

    const [formError, setFormError] = useState({});

    const [allcity, setAllCity] = useState([]);
    const [citydisable, setCityDisable] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const VehicleName = useRef(null);
    const [vehicleDetailList, setVehicleDetailList] = useState([]);
    const [formVehicle, setFormVehicle] = useState({
        VehicleDetailId: 0,
        Price: "",
        VehicleName: "",
        VehicleCategory: "",
        SeatingCapacity: "",
        VehicleType: "",
        BaggageCapacity: ""
    });
    const [vehicleListData, setVehicleListData] = useState([]);

    const [form, setForm] = useState({
        SightseeingId: 0,
        SightseeingName: '',
        LocationId: 0,
        PickupPoint: '',
        DropPoint: '',
        Hours: null,
        ItineraryDetails: '',
        DataCollection: [],
    });

    const columns = [
        {
            name: 'Continent',
            key: 'continentName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.continentName
        },
        {
            name: 'Country',
            key: 'countryName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.countryName
        },
        {
            name: 'Region',
            key: 'regionName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.regionName
        },
        {
            name: 'State',
            key: 'stateName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.stateName
        },
        {
            name: 'City',
            key: 'city',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.city
        },
        {
            name: 'Sightseeing Name',
            key: 'sightseeingName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.sightseeingName
        },
        {
            name: 'Pick Up Point',
            key: 'pickUpPoint',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.pickUpPoint
        },
        {
            name: 'Drop Point',
            key: 'dropPoint',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.dropPoint
        },
        {
            name: 'Hours',
            key: 'hoursFormat',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.hoursFormat,
        },
        {
            name: 'Itinerary Details',
            key: 'itineraryDetails',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.itineraryDetails
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            float: "left",
            selector: (sightseeing) => new Date(sightseeing?.createdDate),
            format: (sightseeing) => sightseeing?.createdDateFormat,
        },
        {
            name: 'Edit',
            selector: (sightseeing) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditView("Edit", sightseeing?.sightseeingId)}></i></button>
        },
        {
            name: 'View',
            selector: (sightseeing) => <i className="fa fa-eye" onClick={() => handleEditView("View", sightseeing?.sightseeingId)}></i>
        }
    ];
    const getSightseeingDataList = async () => {
        const sightseeingListdata = await getAllData("/master/v1/getallsightseeing");
        sightseeingListdata?.data?.map((obj) => {
            obj.Active = obj?.isActive ? 'Active' : 'InActive'
            obj.createdDateFormat = obj?.createdDate ? formatDate(obj?.createdDate) : ""
            obj.hoursFormat = obj?.hours ? formatTimeHourMinute(obj?.hours) : ""
            return obj;
        })
        if (sightseeingListdata?.status) {
            setSightseeingListdata(sightseeingListdata?.data ? sightseeingListdata?.data : []);
            setFilterList(sightseeingListdata?.data ? sightseeingListdata?.data : []);
        }
        else {
            setSightseeingListdata([]);
            setFilterList([]);
        }

    }
    const getCityData = async () => {
        await getAllData('/master/v1/getsightseeingcity').then((cityData) => {
            getSightseeingDataList();
            setCityData(cityData.data?.filter(IsAct => IsAct.isActive === true));
            setAllCity(cityData.data);
            dispatch(loaderActions.end());
        });

    }

    const getvehicleforsightseeing = async () => {
        const vehicleforsightseeing = await getAllData("/master/v1/getvehicleforsightseeing")
        if (vehicleforsightseeing?.status) {
            vehicleforsightseeing?.data?.map((obj) => {
                obj.label = obj?.VehicleName
                obj.value = obj?.VehicleDetailId
                return obj
            })
            setVehicleDetailList(vehicleforsightseeing?.data ? vehicleforsightseeing?.data : [])
        }
        else {
            setVehicleDetailList([]);
        }
    }

    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            //if (Window.$name && Window.$userToken) {
            setCity();
            getCityData();
            getvehicleforsightseeing();
            // getSightseeingDataList().then(() => { dispatch(loaderActions.end()) });;
        }
        else {
            ClearLocalStorage();
            // alert('Your Session Expired. Please Login Again!');
            // navigate('/');
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);
    useEffect(() => {
        // let MENUID = GetMenuIdFromStorage()
        // let viewrights = false;
        // user?.filter(x => x.MenuId === MENUID).map((obj) => {
        //     viewrights = obj.URightView;
        //     setUserAdd(obj.URightAdd);
        //     setUserEdit(obj.URightEdit);
        //     setUserExport(obj.URightExport);
        //     if (!viewrights) {
        //         navigate('/dashboard');
        //     }
        // });
        // let MENUID = GetMenuIdFromStorage()
        // let mid = user?.find(x => x.MenuId === MENUID);
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });

    }, [user])

    const cityList = citydata?.map(value => ({
        label: value?.city,
        value: value?.locationId
    }));

    const handlecity = (e) => {
        setFormError({});
        form.LocationId = e.value
        //getalllocationbyCity(e.value);
        setCity(e.value);
        setEditDisabled(true);

    }
    // const getalllocationbyCity = async (locationId) => {
    //     const locid = { LocationId: locationId }
    //     const AllLocationData = await postUsersData('/general/v1/getsightseeingcity', locid)
    //     setAllLocation(AllLocationData.data);
    // }
    const continent = citydata?.map(value => ({
        label: value?.continentName,
        value: value?.locationId
    })
    );

    const country = citydata?.map(value => ({
        label: value?.countryName,
        value: value?.locationId
    })
    );

    const region = citydata?.map(value => ({
        label: value?.regionName,
        value: value?.locationId
    })
    );

    const state = citydata?.map(value => ({
        label: value?.stateName,
        value: value?.locationId
    })
    );

    const handleSelectVehicle = (ele) => {
        setEditDisabled(true);
        setFormError({});
        setFormVehicle((vcl) => ({
            ...vcl,
            VehicleDetailId: ele?.VehicleDetailId ? ele?.VehicleDetailId : 0,
            VehicleName: ele?.VehicleName ? ele?.VehicleName : "",
            VehicleCategory: ele?.VehicleCategory ? ele?.VehicleCategory : "",
            SeatingCapacity: ele?.SeatingCapacity ? ele?.SeatingCapacity : "",
            VehicleType: ele?.VehicleType ? ele?.VehicleType : "",
            BaggageCapacity: ele?.BaggageCapacity ? ele?.BaggageCapacity : "",
        }))
    }

    const handleChangePrice = (name, value) => {
        setEditDisabled(true);
        setFormError({});
        setFormVehicle((vcl) => ({ ...vcl, [name]: value }))
    }

    const validateVehicleData = () => {
        let status = true;
        let error = {};

        if (formVehicle?.VehicleDetailId === 0 || formVehicle?.VehicleDetailId === null) {
            error.VehicleName = "Please select Vehicle Name";
            status = false;
        }
        if (formVehicle?.Price === 0 || formVehicle?.Price === null || formVehicle?.Price === "") {
            error.Price = "Please enter Price";
            status = false;
        }

        setFormError(error);
        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0]
            if (id === "VehicleName") {
                VehicleName.current?.focus();
            }
            else {
                document.getElementById(id)?.focus();
            }
        }
        return status;
    }

    const checkVehicleDuplicateError = () => {
        let status = true;
        let error = {};

        const checkDuplicate = vehicleListData?.filter((fil) => fil?.VehicleDetailId === formVehicle?.VehicleDetailId)?.length
        if (checkDuplicate > 0) {
            error.VehicleDuplicate = 'You can not enter duplicate Vehicle'
            status = false;
        }
        setFormError(error);
        return status;
    }

    const handleAddVehicle = (e) => {
        e.preventDefault();
        if (validateVehicleData() && checkVehicleDuplicateError()) {
            setVehicleListData((listData) => ([
                ...listData,
                {
                    SeqNo: vehicleListData?.length + 1,
                    VehicleDetailId: formVehicle?.VehicleDetailId,
                    Price: formVehicle?.Price,
                    VehicleName: formVehicle?.VehicleName,
                    VehicleCategory: formVehicle?.VehicleCategory,
                    SeatingCapacity: formVehicle?.SeatingCapacity,
                    VehicleType: formVehicle?.VehicleType,
                    BaggageCapacity: formVehicle?.BaggageCapacity,
                }
            ]))
            setFormVehicle((vcl) => ({
                ...vcl,
                VehicleDetailId: 0,
                Price: "",
                VehicleName: "",
                VehicleCategory: "",
                SeatingCapacity: "",
                VehicleType: "",
                BaggageCapacity: ""
            }))
        }
    }

    const handleRemoveVehicle = (SeqNo) => {
        setEditDisabled(true);
        setFormError({})
        setVehicleListData(vehicleListData?.filter((fil) => fil?.SeqNo !== SeqNo)?.map((obj, index) => ({ ...obj, SeqNo: index + 1 })))
    }

    const onChange = (e) => {
        setFormError({});
        var result;
        if ([e.target.name][0] === 'Price') {
            result = onlyNumeric(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        // setForm({ ...form, [e.target.name]:e.target.value });


        setEditDisabled(true);
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = e
            setActiveId(!activeId)
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        //setYesNoConfirm(e)
        if (e === true) {
            setFormError({});
            form.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(true);
        }
        setModalShow(false);
    }

    const HoursRef = useRef(null);
    const CityError = useRef(null);

    const validateData = () => {
        let status = true;
        let error = {};

        if (form.LocationId <= '0') {
            error.CityError = "Please select city";
            status = false;
        }
        if (form.SightseeingName?.trim()?.length === 0) {
            error.SightseeingName = "Please enter Sightseeing Name";
            status = false;
        }
        if (form.SightseeingName && form.SightseeingName?.trim()?.length > 5000) {
            error.SightseeingName = "Maximum length allowed for Sightseeing Name is 5000 characters";
            status = false;
        }
        if (form.PickupPoint?.trim()?.length === 0) {
            error.PickupPoint = "Please enter PickUp Point";
            status = false;
        }
        if (form.PickupPoint && form.PickupPoint?.trim()?.length > 50) {
            error.PickupPoint = "Maximum length allowed for Pickup Point is 50 characters";
            status = false;
        }
        if (form.DropPoint?.trim()?.length === 0) {
            error.DropPoint = "Please enter Drop Point";
            status = false;
        }
        if (form.DropPoint && form.DropPoint?.trim()?.length > 50) {
            error.DropPoint = "Maximum length allowed for Drop Point is 50 characters";
            status = false;
        }
        if (form.ItineraryDetails?.trim()?.length === 0) {
            error.ItineraryDetails = "Please enter Itinerary Details";
            status = false;
        }
        if (form.ItineraryDetails && form.ItineraryDetails?.trim()?.length > 5000) {
            error.ItineraryDetails = "Maximum length allowed for Itinerary Details is 5000 characters";
            status = false;
        }
        if (vehicleListData?.length === 0) {
            error.VehicleDetailError = "Please enter at least one vehicle detail"
            status = false;
        }

        setFormError(error);

        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            if (id === "CityError") {
                CityError.current?.focus();
            }
            else {
                document.getElementById(id)?.focus();
            }
        }

        return status;
    }
    const checkDuplicateError = () => {
        let status = true;
        let error = {};

        const checkDuplicate = sightseeingListdata?.filter(issec =>
            (buttonaddeditText === 'Add' ? true : issec.sightseeingId !== form?.SightseeingId) &&
            issec.sightseeingName.toLowerCase() === form?.SightseeingName.toLowerCase() &&
            issec.pickUpPoint.toLowerCase() === form?.PickupPoint.toLowerCase() &&
            issec.dropPoint.toLowerCase() === form?.DropPoint.toLowerCase() &&
            issec.itineraryDetails.toLowerCase() === form?.ItineraryDetails.toLowerCase() &&
            issec.locationId === form?.LocationId)?.length

        if (checkDuplicate > 0) {
            error.SightseeingDuplicate = 'You can not enter duplicate value'
            status = false;
        }
        setFormError(error);
        return status;
    }

    const handleAddClick = async () => {
        if (validateData() && checkDuplicateError()) {
            form.DataCollection = vehicleListData?.map((obj) => ({ VehicleDetailId: Number(obj?.VehicleDetailId), Price: Number(obj?.Price) }));
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const SightseeingData = buttonaddeditText === 'Add' ?
                    await postUsersData("/master/v1/insertsightseeing", form)
                    :
                    await patchUsersData("/master/v1/updatesightseeing", form)

                if (SightseeingData?.status) {
                    dispatch({ type: 'ALERTING', message: SightseeingData?.message })
                    clear();
                    getSightseeingDataList();
                }
                else {
                    dispatch({ type: 'ALERTING', message: SightseeingData?.message })
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }

    };
    const handleEditView = (type, id) => {
        setDisabled(type === "Edit" ? false : true);
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        setEditDisabled(false);
        setSearchDisabled(true);
        RetriveData(id);
    }

    const RetriveData = (id) => {
        setFormError({});
        sightseeingListdata.filter(objid => objid.sightseeingId === id)?.map(obj => {
            setForm({
                ...form,
                SightseeingId: obj.sightseeingId,
                SightseeingName: obj.sightseeingName,
                LocationId: obj.locationId,
                PickupPoint: obj.pickUpPoint,
                DropPoint: obj.dropPoint,
                Hours: obj.hours,
                ItineraryDetails: obj.itineraryDetails,
                IsActive: obj.isActive,
                VehicleTypeId: obj.vehicleTypeId,
            })
            let allcitylist = allcity?.filter(IsAct => IsAct.isActive === true);
            setCityData(allcity?.filter(IsAct => IsAct.isActive === true));
            setCityDisable(false);
            if (!allcitylist?.find(IsCity => IsCity.locationId === obj.locationId)) {
                setCityDisable(true)
                setCityData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allcity?.find(isCity => isCity.locationId === obj.locationId)] : [])

            }
            setCity(obj.locationId);
            setActiveId(obj.isActive);
            setHoursTime(obj.hours ? dayjs(obj.hours) : null)
            obj?.dataCollection?.map((coll, index) => {
                coll.VehicleDetailId = coll.vehicleDetailId
                coll.VehicleName = coll.vehicleName
                coll.VehicleCategory = coll.vehicleCategory
                coll.SeatingCapacity = coll.seatingCapacity
                coll.VehicleType = coll.vehicleType
                coll.BaggageCapacity = coll.baggageCapacity
                coll.Price = coll.price
                coll.SeqNo = index + 1

                return coll;
            })
            setVehicleListData(obj?.dataCollection ? obj?.dataCollection : [])
        });

    }
    const handleClearClick = () => {
        clear();
    }
    function clear() {
        setFormError({});
        setForm({
            ...form, SightseeingName: '', PickupPoint: '', DropPoint: '', Hours: null,
            ItineraryDetails: '', IsActive: false, LocationId: 0, DataCollection: []
        });
        setForm((form) => ({
            ...form,
            SightseeingName: '', PickupPoint: '', DropPoint: '', Hours: null,
            ItineraryDetails: '', IsActive: false, LocationId: 0, DataCollection: []
        }))
        getSightseeingDataList();
        setActiveId(false);
        setDisabled(false);
        setEditDisabled(true);
        setSearchDisabled(false);
        setSerachBy('All');
        setSearchValue('');
        setCity(0);
        setButtonAddEditText('Add');
        setActiveId(0);
        setEditDisabled(true);
        setHoursTime(null);
        setCityDisable(false);

        setVehicleListData([]);
        setFormVehicle((vcl) => ({
            ...vcl,
            VehicleDetailId: 0,
            Price: "",
            VehicleName: "",
            VehicleCategory: "",
            SeatingCapacity: "",
            VehicleType: "",
            BaggageCapacity: ""
        }));
    }

    function PdfExport() {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = sightseeingListdata?.map((obj) => keys?.map((key) => obj[key]))
        generatePDF(pdfColumns, rows, "SightseeingMaster", "Sightseeing Master", "l")
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, sightseeingListdata, "SightseeingMaster", "SightseeingMaster.xls");
    }

    //#region time format
    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    }
    function ChangeDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const handleonchangeofTime = (name, times) => {
        setEditDisabled(true);
        setFormError({});
        setHoursTime(times);
        setForm((form) => ({ ...form, [name]: times ? `${ChangeDate(new Date())}T${TimeHour(times)}:00:00` : times }));
    }
    //#endregion time format
    return (
        <>

            <div className="container-fluid mt-4 heading_color">
                <h3>Sightseeing Master</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                {formError?.SightseeingDuplicate && <p className='text-danger text-start mb-0'>{formError?.SightseeingDuplicate}</p>}
                                <div className='col-lg-2 col-sm-6 mx-lg-auto ms-lg-0'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Continent</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={continent?.find(({ value }) => value === cityid)}
                                            options={continent}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Country</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={country?.find(({ value }) => value === cityid)}
                                            options={country}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Region</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={region?.find(({ value }) => value === cityid)}
                                            options={region}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">State</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={state?.find(({ value }) => value === cityid)}
                                            options={state}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto me-lg-0'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">City</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <CustomSelection
                                            selId="CityError"
                                            selRef={CityError}
                                            datalist={cityList}
                                            fieldid={cityid}
                                            SelectionChange={handlecity}
                                            isdisable={disabled}
                                            isactivedisable={citydisable}
                                            issearchable={true}
                                        />
                                        {formError?.CityError && <p className='text-danger mb-0'>{formError?.CityError}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-1 mt-4 col-lg-11 mx-lg-5">
                        <div className='row'>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>

                                    <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Sightseeing Name</label>
                                    </div>
                                    <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                        <textarea type="text"
                                            id="SightseeingName"
                                            className="form-control enquiry_boder py-2 mx-auto"
                                            name="SightseeingName"
                                            value={form.SightseeingName}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Sightseeing Name'
                                        // maxLength={5000}
                                        />
                                        {formError?.SightseeingName && <p className='text-danger mb-0'>{formError?.SightseeingName}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Pick Up Point</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="PickupPoint"
                                            className="form-control"
                                            name='PickupPoint'
                                            value={form.PickupPoint}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Pick Up Point'
                                        />
                                        {formError?.PickupPoint && <p className='text-danger mb-0'>{formError?.PickupPoint}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Drop Point</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="DropPoint"
                                            className="form-control"
                                            name="DropPoint"
                                            value={form.DropPoint}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Drop Point'
                                        />
                                        {formError?.DropPoint && <p className='text-danger mb-0'>{formError?.DropPoint}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label">Hours</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <TimePicker
                                            ref={HoursRef}
                                            id='Hours'
                                            className='form-control defo_border'
                                            disabled={disabled ? true : false}
                                            placeholder='--'
                                            format='HH'
                                            value={hoursTime}
                                            needConfirm={false}
                                            disabledTime={() => ({
                                                disabledMinutes: () => {
                                                    // Disable every minute except 0
                                                    return Array.from({ length: 60 }, (_, i) => i).filter(i => i !== 0);
                                                }
                                            })}
                                            showNow={false}
                                            onChange={(e) => handleonchangeofTime("Hours", e)}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={disabled ? true : false}
                                        // disabled={disabled ? true : false}
                                        />
                                    </div>
                                    {/* <div className=" col-auto col-lg-4"> */}
                                    <ConfirmationModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        noconfirm={() => handleConfirmation(false)}
                                        yesconfirm={() => handleConfirmation(true)}
                                    />

                                    {/* </div> */}
                                </div>
                            </div>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>
                                    <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Itinerary Details</label>
                                    </div>
                                    {/* <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1"> */}
                                    <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                        <textarea type="text"
                                            id="ItineraryDetails"
                                            className="form-control enquiry_boder py-2 mx-auto"
                                            name="ItineraryDetails"
                                            value={form.ItineraryDetails}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Itinerary Details'
                                        // maxLength={5000}
                                        />
                                        {formError?.ItineraryDetails && <p className='text-danger mb-0'>{formError?.ItineraryDetails}</p>}
                                    </div>

                                </div>
                            </div>
                            {/* <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={disabled ? true : false}
                                        // disabled={disabled ? true : false}
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <div className="col-lg-12 mx-1">
                            <label htmlFor="inputPassword" className=" col-form-label fw-bolder">Vehicle Details</label>
                        </div>
                        <div className="col-lg-12">

                            <div className="mb-3 row mx-1 form_border py-3">
                                <div className='col-12 '>
                                    {formError?.VehicleDetailError && <p className="text-danger text-center"> {formError?.VehicleDetailError} </p>}
                                    {formError?.VehicleDuplicate && <p className="text-danger text-center"> {formError?.VehicleDuplicate} </p>}
                                    <div className="row">

                                        <div className="col-lg-4 col-md-4 col-12 mb-1">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                    <label htmlFor="VehicleName" className="col-form-label required">Vehicle Name</label>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                    <Select className="dropdown select_dropdown"
                                                        id="VehicleName"
                                                        ref={VehicleName}
                                                        name='VehicleName'
                                                        options={vehicleDetailList}
                                                        value={vehicleDetailList?.filter((fil) =>
                                                            fil?.value === formVehicle?.VehicleDetailId
                                                        )}// set list of the data
                                                        onChange={(e) => handleSelectVehicle(e)}// assign onChange function
                                                        isDisabled={disabled ? true : false}
                                                    />
                                                    {formError?.VehicleName && <p className="text-danger mb-0"> {formError?.VehicleName} </p>}
                                                </div>

                                                <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                    <label htmlFor="Price" className="col-form-label required">Price</label>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="Price"
                                                        id="Price"
                                                        value={formVehicle?.Price}
                                                        placeholder='Price'
                                                        maxLength={10}
                                                        onChange={(e) => {
                                                            onlyNumeric(e.target.value)?.length <= 10 &&
                                                                handleChangePrice(e.target.name, onlyNumeric(e.target.value))
                                                        }}
                                                        disabled={disabled ? true : false}
                                                    />
                                                    {formError?.Price && <p className="text-danger mb-0"> {formError?.Price} </p>}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-lg-8 col-md-8 col-12 mb-1">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-12 mb-1">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                            <label htmlFor="PaxCapacity" className="col-form-label">Pax Capacity</label>
                                                        </div>
                                                        <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="PaxCapacity"
                                                                id="PaxCapacity"
                                                                placeholder='Pax Capacity'
                                                                value={formVehicle?.SeatingCapacity}
                                                                onChange={() => { }}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-12 mb-1">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                            <label htmlFor="VehicleCategory" className="col-form-label">Vehicle Category</label>
                                                        </div>
                                                        <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="VehicleCategory"
                                                                id="VehicleCategory"
                                                                placeholder='Vehicle Category'
                                                                value={formVehicle?.VehicleCategory}
                                                                onChange={() => { }}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-12 mb-1">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                            <label htmlFor="VehicleType" className="col-form-label">Vehicle Type</label>
                                                        </div>
                                                        <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="VehicleType"
                                                                id="VehicleType"
                                                                placeholder='Vehicle Type'
                                                                value={formVehicle?.VehicleType}
                                                                onChange={() => { }}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-12 mb-1">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-4 col-12 mb-1">
                                                            <label htmlFor="BaggageCapacity" className="col-form-label">Baggage Capacity</label>
                                                        </div>
                                                        <div className="col-lg-8 col-md-8 col-12 mb-1">
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                name="BaggageCapacity"
                                                                id="BaggageCapacity"
                                                                placeholder='Baggage Capacity'
                                                                value={formVehicle?.BaggageCapacity}
                                                                onChange={() => { }}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-12 text-center">
                                            <button
                                                className="btn btn-primary mx-1"
                                                type="button"
                                                id='addvehicle'
                                                onClick={(e) => handleAddVehicle(e)}
                                                disabled={editdisabled ? false : true}
                                            >
                                                Add
                                            </button>
                                        </div>

                                    </div>


                                    <div className='mb-1 col-lg-12 col-md-12 mt-3 overflow-auto'>
                                        <table id="data" className="table table-hover" >
                                            <thead>
                                                <tr>
                                                    <th> Vehicle Name </th>
                                                    <th> Price </th>
                                                    <th> Pax Capacity </th>
                                                    <th> Vehicle Category </th>
                                                    <th> Vehicle Type </th>
                                                    <th> Baggage Capacity </th>
                                                    <th> Remove </th>
                                                </tr>
                                            </thead>
                                            <tbody id="location-data">
                                                {vehicleListData?.map((obj) => {
                                                    return (
                                                        <tr className="ReactTable" key={obj?.VehicleDetailId}>
                                                            <td>{obj.VehicleName}</td>
                                                            <td>{obj.Price}</td>
                                                            <td>{obj.SeatingCapacity}</td>
                                                            <td>{obj.VehicleCategory}</td>
                                                            <td >{obj.VehicleType}</td>
                                                            <td>{obj.BaggageCapacity}</td>
                                                            <td><button type="button" onClick={(e) => handleRemoveVehicle(obj.SeqNo)} disabled={disabled ? true : false} className="btn btn-primary mx-1" id="btnAdd" >Remove</button></td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getSightseeingDataList}
                        setlistdata={setSightseeingListdata}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={sightseeingListdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default Sightseeingmaster